var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43 2.65221C4.25885 2.55514 4.06523 2.50465 3.86847 2.5058C3.67172 2.50694 3.4787 2.55966 3.30868 2.65871C3.13867 2.75776 2.99761 2.89966 2.89958 3.07027C2.80154 3.24087 2.74997 3.43419 2.75 3.63096V16.375C2.74997 16.5717 2.80154 16.765 2.89958 16.9356C2.99761 17.1062 3.13867 17.2482 3.30868 17.3472C3.4787 17.4463 3.67172 17.499 3.86847 17.5001C4.06523 17.5013 4.25885 17.4508 4.43 17.3537L15.6777 10.9802C15.8509 10.8821 15.9949 10.7398 16.0951 10.5679C16.1953 10.3959 16.2481 10.2005 16.2481 10.0015C16.2481 9.80245 16.1953 9.60701 16.0951 9.43506C15.9949 9.26312 15.8509 9.12082 15.6777 9.02271L4.42925 2.65146L4.43 2.65221ZM1.25 3.63096C1.25 1.62021 3.41825 0.355706 5.16875 1.34646L16.4165 7.71621C18.1917 8.72121 18.1925 11.2787 16.4172 12.2837L5.1695 18.6587C3.419 19.6487 1.25 18.385 1.25 16.3735V3.63246V3.63096Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorPlay);
export default __webpack_public_path__ + "static/media/EditorPlay.676044e637425aa434b826ddeea50cfe.svg";
export { ForwardRef as ReactComponent };